// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"99e496de","93":"f3535bb6","214":"00bc40fc","216":"2fb8c445","274":"0c8863e2","680":"98a0c5b5","754":"150295e7","859":"f0f97dde","908":"85aae2cf","973":"806752ba"}[chunkId] + ".chunk.js";
};